import clsx from 'clsx';
import React, { useState } from 'react';
import { TbAlertCircle } from 'react-icons/tb';

interface CodePromotionButtonsProps {
  active?: boolean;
  isLoading?: boolean;
  onDeleteClick: () => void;
  onToggleClick: () => void;
}

export const CodePromotionButtons = ({ active = true, onDeleteClick, onToggleClick, isLoading }: CodePromotionButtonsProps) => {
  const [confirmDelete, setConfirmDelete] = useState(false);

  const handleDeleteClick = () => {
    if (confirmDelete) {
      onDeleteClick();
      setConfirmDelete(false);
    } else {
      setConfirmDelete(true);
    }
  };

  const cancelDelete = () => setConfirmDelete(false);

  return (
    <div
      className={clsx(
        isLoading ? 'bg-gray-300' : 'bg-gray-100',
        confirmDelete ? 'border-red-600 bg-red-100' : 'border-gray-200',
        'divide-x divide-gray-200  flex justify-between border w-fit rounded-lg mx-auto text-black overflow-auto'
      )}
    >
      {!confirmDelete && (
        <button
          className={clsx(isLoading ? 'hover:cursor-not-allowed' : 'hover:bg-primary hover:text-white', 'duration-200 px-5 ease-in-out py-2')}
          onClick={onToggleClick}
          disabled={isLoading}
        >
          {active ? 'Désactiver' : 'Activer'}
        </button>
      )}

      {confirmDelete ? (
        <>
          <button
            className="hover:bg-red-600 font-medium  hover:text-white duration-200 px-5 ease-in-out py-2"
            onClick={handleDeleteClick}
            disabled={isLoading}
          >
            Confirmer la suppression
          </button>
          <button className="hover:bg-primary hover:text-white duration-200 px-5 ease-in-out py-2" onClick={cancelDelete} disabled={isLoading}>
            Annuler
          </button>
        </>
      ) : (
        <button
          className={clsx(isLoading ? 'hover:cursor-not-allowed' : 'hover:bg-primary hover:text-white', 'duration-200 px-5 ease-in-out py-2')}
          onClick={handleDeleteClick}
          disabled={isLoading}
        >
          Supprimer
        </button>
      )}
    </div>
  );
};
